import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import {
  Environment,
  ITicketsGruppiCategorieSub_TModel,
  TicketsCatSubPersoneGruppi,
  ITicketsGruppiCategoriaSub,
  ModelNumStr,
} from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class TicketsGruppiCategorieService extends CrudGenericsService<TicketsCatSubPersoneGruppi, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/TicketsGruppiCategorie`);
    this.base = `${env.apiUrl}/api/TicketsGruppiCategorie/`;
  }
  // per la tabella
  GetTicketsCategorie_TableModel(): Observable<ITicketsGruppiCategorieSub_TModel[]> {
    const u = this.base + 'GetTicketsGruppiCategorie_TModel';
    return this.http.get<ITicketsGruppiCategorieSub_TModel[]>(`${u}`);
  }

  GetTickets_CategoriaSubGruppi(idCatSub: any) {
    const u = this.base + 'GetTickets_CategoriaSubGruppi';
    let data = { idCategoriaSub: idCatSub };
    return this.http.get<ITicketsGruppiCategoriaSub>(`${u}`, { params: data });
  }

  Save_CategorieSubGruppi(dati: ITicketsGruppiCategoriaSub) {
    const url = this.base + 'Save_CategorieSubGruppi';
    return this._http.post<ITicketsGruppiCategoriaSub>(url, dati);
  }

  Delete_CategorieSubGruppi(dati: ModelNumStr) {
    const url = this.base + 'Delete_CategorieSubGruppi';
    return this._http.post(url, dati);
  }
}
